export default __webpack_public_path__ + "static/media/hireAg.9731c1a5.jpg";